(ns app.ui.campaigns.flights.bid-modifiers
  (:require ["/js/components/bid-modifiers-flight-panel/bid-modifiers-container" :default BidModifiersContainer]
            ["/js/components/bid-modifiers-flight-panel/bid-modifiers-flight-panel" :default BidModifiersFlightPanel]
            [app.rpc                                                             :as    rpc]
            [hoplon.core                                                         :refer [a
                                                                                         cond-tpl
                                                                                         defelem
                                                                                         div
                                                                                         h5
                                                                                         if-tpl
                                                                                         span
                                                                                         strong
                                                                                         when-tpl]]
            [javelin.core                                                        :refer [cell=
                                                                                         dosync]]
            [ui.button                                                           :as    button]
            [ui.helix-hoplon                                                     :as helix-hoplon]
            [ui.icon                                                             :as icon]
            [ui.util                                                             :as util]
            [app.ui.version :as version]))

(defelem panel
  [{:keys [_flight flight-form panelExpanded collapseDisabled onInUseChange onPanelExpandedChange
           ;; Old UI
           is-collapsible is-expanded disabled
           tooltip-text in-use adzerk-logical-id on-change]}
   _children]
  (let [channel-id             (-> flight-form :data :prioritychannelid)
        flight-id              (-> flight-form :data :id)
        is-expanded            (util/ensure-cell is-expanded)
        in-use                 (util/ensure-cell in-use)
        user-access-level      rpc/user-access-level
        feature-flags          rpc/feature-flags
        current-flight-data    (:data rpc/current-flight)]

    (util/on-change current-flight-data
                    #(dosync
                      (let [bid-modifiers (get-in % [0 :bidmodifiers])]
                        (reset! in-use (boolean (seq bid-modifiers)))
                        (when (boolean (seq bid-modifiers))
                          (reset! is-expanded true)))))

    (if version/new-version?
      (helix-hoplon/mount-react-js
       BidModifiersContainer
       {:input                 (cell= {:channelId       channel-id
                                       :flightId        flight-id
                                       :userAccessLevel user-access-level
                                       :featureFlags    (clj->js (for [[flag enabled?] feature-flags :when enabled?] (name flag)))})
        :bidModifiers          (cell= (clj->js (get-in current-flight-data [0 :bidmodifiers])))
        :panelExpanded         panelExpanded
        :collapseDisabled      collapseDisabled
        :onInUseChange         onInUseChange
        :onPanelExpandedChange onPanelExpandedChange
        ;; The bid-modifiers save/delete calls only ever PATCH BidModifiers on
        ;; the flight (see update-flight! on the backend: "Geir uses partial
        ;; update so omitting it here won't cause an issue"), and the response
        ;; already contains the fully up-to-date flight. Rather than calling
        ;; p/refresh! (which re-fetches rpc/current-flight from the backend
        ;; and stamps a fresh :nonce on it), which cascades into every sibling
        ;; panel's own pager via their `(p/watch-map page {:flightid :id
        ;; :nonce :nonce} flight)` - refetching site/zone targeting,
        ;; geo-targeting, geodistance, day-parting, and segment-targeting even
        ;; though none of that data changed - we merge just the returned
        ;; BidModifiers directly into rpc/current-flight's local data. This
        ;; keeps :nonce untouched, so no sibling panel refetches, while still
        ;; keeping current-entity/current-flight-data (and therefore the
        ;; :in-use badge here and the bidModifiers prop below) in sync.
        ;;
        ;; The shapes line up: castra's :bidmodifiers is produced by
        ;; safe-parse-json (keywordized, case preserved) over the raw
        ;; BidModifiers JSON blob, which is stored/returned in the same
        ;; PascalCase {Match, Multiplier, Price} shape as the management API's
        ;; Flight/BidModifier response used here.
        :onFlightUpdate
        (fn [updated-flight]
          (let [bid-modifiers (:BidModifiers (js->clj updated-flight :keywordize-keys true))]
            (swap! (:data rpc/current-flight)
                   (fn [flights] (assoc-in flights [0 :bidmodifiers] bid-modifiers)))))})

      (div
       :adzerk-logical-id adzerk-logical-id
       :class (cell=
               {"panel"         true
                "panel-default" true
                "collapsible"   is-collapsible
                "border-danger" (and disabled
                                     is-collapsible)})
       (if-tpl is-collapsible
               (button/primary
                :class                "panel-heading collapsible"
                :adzerk-logical-class "panel-heading"
                :disabled             disabled
                :click                (fn [event] (.preventDefault event)
                                        (swap! is-expanded not))
                (h5 :css {:flex-grow 1}
                    (rpc/from-lang-pack ::panel-default-heading)
                    (when-tpl in-use
                              (span :class                "in-use-badge"
                                    :adzerk-logical-class "in-use-badge"
                                    :tooltip-top          (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/in-use-badge-tooltip)
                                    ((icon/check))
                                    " "
                                    (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/in-use-badge))))
                (cond-tpl
                 (cell= (and disabled is-expanded))
                 (span :tooltip-top tooltip-text
                       (icon/up :class "tooltip-trigger"))

                 (cell= (and disabled (not is-expanded)))
                 (span :tooltip-top tooltip-text
                       (icon/down :class "tooltip-trigger"))

                 is-expanded
                 (icon/up)

                 (cell= (not is-expanded))
                 (icon/down)))

               (div :class "panel-heading"
                    :adzerk-logical-class "panel-heading"
                    (h5 (rpc/from-lang-pack ::panel-default-heading)
                        (span :class "in-use-badge"
                              :adzerk-logical-class "in-use-badge"
                              :tooltip-top (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/in-use-badge-tooltip)
                              ((icon/check))
                              " " (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/in-use-badge)))))

       (when-tpl
        (cell= (or is-expanded
                   (not is-collapsible)))
        (div
         (div
          :class "alert alert-info"
          :style "margin-bottom:0px; margin-top:0px; padding-left:30px; padding-right:30px;"
          (div (strong (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/panel-bid-modifiers-alert-1)))
          (div (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/panel-bid-modifiers-alert-2))
          (div (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/panel-bid-modifiers-alert-3)
               (a
                :style
                "margin-left: .5em;"

                :adzerk-logical-id
                "bid-modifiers-help-topic-link"

                :href
                "https://dev.kevel.com/docs/bid-modifiers"

                :target
                "_blank"

                :aria-label
                (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/panel-bid-modifiers-help-message-aria-label)

                (rpc/from-lang-pack :app.ui.campaigns.flights.edit-legacy/panel-bid-modifiers-help-message))))
         (div
          :class "collapse-in"
          :id    "panel-bid-modifiers"
          (div
           :class                "panel-body"
           :adzerk-logical-class "panel-body"
           (helix-hoplon/mount-react-js
            BidModifiersFlightPanel
            {:channelId       channel-id
             :flightId        flight-id
             :userAccessLevel user-access-level
             :featureFlags    (cell= (clj->js (for [[flag enabled?] feature-flags :when enabled?] (name flag))))
             :events          {:onChange on-change}})))))))))
